import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {getHomePageUrl} from '../../../../../../commons/selectors/environment'
import {useAppSelector} from '../../../hooks/runtime'
import s from './back-to-site-link.scss'

export const BackToSiteLink = ({className, children}: PropsWithChildren<{className?: string}>) => {
  const {t} = useTranslation()
  const url = useAppSelector(getHomePageUrl)

  if (!url) {
    return null
  }

  return (
    <a className={classNames(s.link, className)} data-hook={DH.BACK_TO_SITE} href={url}>
      {children ?? t('backToSite')}
    </a>
  )
}
